export default "__VITE_ASSET__BN_xTS6r__"